import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressPipe } from '@lockton-apps/shared/ui/lui';
import { CastArrayPipe } from '@lockton-apps/shared/util/ng-lodash';
import { DynamicFormCellComponent } from './dynamic-form-cell.component';
import { MaterialModule } from '@lockton-apps/material';
import { MatchingLabelPipe } from '../pipes/matching-label/matching-label.pipe';

@NgModule({
  declarations: [DynamicFormCellComponent],
  imports: [
    CommonModule,
    CastArrayPipe,
    MaterialModule,
    AddressPipe,
    MatchingLabelPipe,
  ],
  exports: [DynamicFormCellComponent],
})
export class DynamicFormCellModule {}
